import script from "./ResolutionFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./ResolutionFilters.vue?vue&type=script&setup=true&lang=js"

import "./ResolutionFilters.vue?vue&type=style&index=0&id=75702ba3&scoped=true&lang=css"

import exportComponent from "/Users/tobiaskauer/Projects/pema/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75702ba3"]])

export default __exports__